var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 96,
    viewBox: "0 0 240 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6976 31.7488L70.0956 34H9.0808L1 20H61.6816C67.8192 20 72.2852 25.8212 70.6976 31.7488ZM74.6428 20L79.05 27.63L71.7168 55H86.2096L95.5868 20H74.6456H74.6428ZM68.2196 41H29.5124C26.6956 41 24.2316 42.8928 23.5008 45.6116L15.3612 76H29.8512L34.8604 57.3072C35.2244 55.9464 36.4564 55 37.8648 55H49.9748L44.3468 76H80.5788L84.3308 62H62.5888L68.2168 41H68.2196Z",
    fill: "#E4450A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.587 35.5148H122.013V69.28H132.001V35.5148H144.427V27.2884H109.587V35.5148Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.236 26.72C155.832 26.72 148.227 33.4736 148.227 43.6292V69.28H158.212V58.0436H176.202V69.28H186.192V43.6292C186.192 33.4708 178.588 26.72 167.236 26.72ZM176.202 49.8172H158.212V44.0268C158.212 38.5808 161.788 34.9492 167.292 34.9492C172.797 34.9492 176.202 38.578 176.202 44.0268V49.8172Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.034 27.2884H194.047V69.28H221.851V61.0508H204.034V27.2884Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M239.731 27.2884H229.743V69.28H239.731V27.2884Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.9a13b25ca4e88b8df03c067f8f6ab23c.svg";
export { ForwardRef as ReactComponent };